export enum WidgetType {
  MOCK_WIDGET = 'mockWidget',
  BALANCE_HISTORY = 'balanceHistory',
  BALANCE_BY_CURRENCIES = 'balanceByCurrencies',
  BALANCE_BY_OWN_GROUPS = 'balanceByOwnGroups',
  BALANCE_BY_BANKS = 'balanceByBanks',
  BALANCE_BY_COUNTRIES = 'balanceByCountries',
  RECENT_PAYMENTS = 'recentPayments',
  DROP_ZONE = 'dropZone',
  NEW_PAYMENT = 'newPayment',
}

export enum SignatureType {
  OPEN = 'signature_status_none',
  UNSIGNED = 'signature_status_unsigned',
  UNSIGNED_DISABLED = 'signature_status_unsigned_disabled',
  PARTIALLY_SIGNED = 'signature_status_partially',
  PARTIALLY_SIGNED_DISABLED = 'signature_status_partially_disabled',
  SIGNED = 'signature_status_signed',
  SIGNATURE_STATUS_ERROR = 'signature_status_error',
}

export enum OrderState {
  REQUESTED = 'REQUESTED',
  OPEN = 'OPEN',
  UNSIGNED = 'UNSIGNED',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  FULLY_SIGNED = 'FULLY_SIGNED',
  FAILED = 'FAILED',
  SANCTION_HIT = 'SANCTION_HIT',
  SANCTION_SCREENING = 'SANCTION_SCREENING',
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  INSERTING = 'INSERTING',
  IMPORTING = 'IMPORTING',
  IMPORT_ERROR = 'IMPORT_ERROR',
  PROCESSING = 'PROCESSING',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  CONVERTING = 'CONVERTING',
  CONVERTED = 'CONVERTED',
  CONVERSION_ERROR = 'CONVERSION_ERROR',
  CONVERTING_RELEASE = 'CONVERTING_RELEASE',
  CONVERTED_RELEASE = 'CONVERTED_RELEASE',
  CONVERSION_ERROR_RELEASE = 'CONVERSION_ERROR_RELEASE',
  MISSING_SIGN_OFF_REQUIREMENTS = 'MISSING_SIGN_OFF_REQUIREMENTS',
  RELEASING = 'RELEASING',
  RELEASED = 'RELEASED',
  RELEASE_ERROR = 'RELEASE_ERROR',
  RELEASED_TO_BANK = 'RELEASED_TO_BANK',
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  COMPLETED_WITH_ERROR = 'COMPLETED_WITH_ERROR',
  COMPLETED_SUCCESSFULLY = 'COMPLETED_SUCCESSFULLY',
}

export enum ClientFileStatus {
  OPEN = 'OPEN',
  MISSING_SIGN_OFF_REQUIREMENTS = 'MISSING_SIGN_OFF_REQUIREMENTS',
  UNSIGNED = 'UNSIGNED',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  FULLY_SIGNED = 'FULLY_SIGNED',
}

export enum TemplateTypes {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export type Signature = {
  signer: { username: string };
  timestamp: Date;
};

export interface OrderContent {
  status: string;
  signableByUser: boolean;
  orderId: number;
  actualControlSum: number;
  actualNumberOfTransactions: number;
  created: string;
  createdBy: { username: string };
  signatures: Signature[];
  warnings: string[];
}
